import { Controller } from "@hotwired/stimulus";

// select_all_checkboxes_controller とは用途が異なる。
// あちらは点検画面の「全て問題なし」用（全件ONのみ）。
// こちらは帳票出力画面・点検一覧画面の絞り込みリスト用で、
// 表示中のみ対象・選択/解除の両方・フィルター連動に対応。
export default class extends Controller {
  selectAll(): void {
    this.toggleVisibleCheckboxes(true);
    this.dispatch("bulk-change");
  }

  deselectAll(): void {
    this.toggleVisibleCheckboxes(false);
    this.dispatch("bulk-change");
  }

  private toggleVisibleCheckboxes(checked: boolean): void {
    this.element.querySelectorAll<HTMLInputElement>('input[type="checkbox"]').forEach((checkbox) => {
      if (!this.isVisible(checkbox) || checkbox.checked === checked) {
        return;
      }
      checkbox.checked = checked;
    });
  }

  private isVisible(el: HTMLElement): boolean {
    let current: HTMLElement | null = el;
    while (current && current !== this.element) {
      if (current.style.display === "none") return false;
      current = current.parentElement;
    }
    return true;
  }
}
